import { render, staticRenderFns } from "./MiraDotPlot.vue?vue&type=template&id=53276afc&scoped=true&"
import script from "./MiraDotPlot.vue?vue&type=script&lang=ts&"
export * from "./MiraDotPlot.vue?vue&type=script&lang=ts&"
import style0 from "./MiraDotPlot.vue?vue&type=style&index=0&id=53276afc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53276afc",
  null
  
)

export default component.exports